// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Cross,
    Crosshair,
    Crown,
    Cuboid,
    CupSoda,
    Currency,
    Cylinder,
    Dam,
    Database,
    DatabaseArrowDown,
    DatabaseArrowUp,
    DatabaseBackup,
    DatabaseCheck,
    DatabaseMinus,
    DatabasePlus,
    DatabaseSearch,
    DatabaseX,
    DatabaseZap,
    DecimalsArrowLeft,
    DecimalsArrowRight,
    Delete,
    Dessert,
    Diameter,
    Diamond,
    DiamondMinus,
    DiamondPercent,
    DiamondPlus,
    Dice1,
    Dice2,
    Dice3,
    Dice4,
    Dice5,
    Dice6,
    Dices,
    Diff,
    Disc,
    Disc2,
    Disc3,
    DiscAlbum,
    Divide,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "cross" through "divide", inclusive. */
const shard: Record<string, LucideIcon> = {
    cross: Cross,
    crosshair: Crosshair,
    crown: Crown,
    cuboid: Cuboid,
    "cup-soda": CupSoda,
    currency: Currency,
    cylinder: Cylinder,
    dam: Dam,
    database: Database,
    "database-arrow-down": DatabaseArrowDown,
    "database-arrow-up": DatabaseArrowUp,
    "database-backup": DatabaseBackup,
    "database-check": DatabaseCheck,
    "database-minus": DatabaseMinus,
    "database-plus": DatabasePlus,
    "database-search": DatabaseSearch,
    "database-x": DatabaseX,
    "database-zap": DatabaseZap,
    "decimals-arrow-left": DecimalsArrowLeft,
    "decimals-arrow-right": DecimalsArrowRight,
    delete: Delete,
    dessert: Dessert,
    diameter: Diameter,
    diamond: Diamond,
    "diamond-minus": DiamondMinus,
    "diamond-percent": DiamondPercent,
    "diamond-plus": DiamondPlus,
    "dice-1": Dice1,
    "dice-2": Dice2,
    "dice-3": Dice3,
    "dice-4": Dice4,
    "dice-5": Dice5,
    "dice-6": Dice6,
    dices: Dices,
    diff: Diff,
    disc: Disc,
    "disc-2": Disc2,
    "disc-3": Disc3,
    "disc-album": DiscAlbum,
    divide: Divide,
};

export default shard;
